export const AUTH_USER_KEY = "__user__";
export const AUTH_MAYCA_KEY = '__mayca__user'
export const TOKEN_KEY = "__token__";
export const TOKEN_MAYCA_KEY = "__mayca__token"

export const ROLE_MAYCA = "__role__";
